/*
ge-datepicker.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/widgets/datepicker/ge-datepicker',[
    'lodash',
    'jquery',
    'angular',
    '../../services/system-language.service',
    'jquery-ui',
    'jquery-ui-i18n'
], function (_, $, angular, systemLanguageService) {
    'use strict';

    // Module for GE Jquery UI Datepicker
    var mod = angular.module('GeDatePicker', []);

    /*
    * Directive for GE Jquery UI Datepicker
    * Use this directive to attach the date picker functionality on input textbox.
    *
    * @usage:
    * Apply the directive as an attribute to your element.
    * For example:
    *   <input  ge-date-picker
            type               = "text"
            id                 = "patientDate"
            name               = "patientDate"
            ng-model           = "pacsData.birthDate"
            class              = "input-large">
    */
    mod.run(['$rootScope', function ($rootScope) {
        $rootScope.$on('$stateChangeStart', function () {
            $('#ui-datepicker-div').hide();
        });
    }]);

    mod.directive('geDatePicker', ['$filter', 'localizedOptions', function ($filter, localizedOptions) {
        // TODO : Move this to some common / utility file.
        Date.prototype.getApiFormat = function () {
            // Since Date.getMonth() is "0" based, we need to add 1 to it.
            var month = this.getMonth() + 1;
            // If month is less than 10, then format it to 2 digit number
            if (month < 10) {
                month = '0' + month;
            }

            // If day is less than 10, then format it to 2 digit number
            var day = this.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            // Finally return the date string in to the API format : yyyyMMdd
            // This format is strictly for sending date to the api.
            return this.getFullYear().toString() + '' + month.toString() + '' + day.toString();
        };

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                // element is an array. Pull the first one as the main element
                var $element = angular.element(element[0]);

                var today = new Date();
                // This is to sync with EA / SQL Server date. EA doesn't support the date before 01 Jan 1973.
                var EA_START_DATE = new Date('31 Dec 1752');
                EA_START_DATE.setHours(11, 59, 59);
                var startDate, START_DATE_EXPR = $element.attr('start-date-expr');

                var END_DATE, FutureDateAllowed = $element.attr('future-date-allowed');
                switch (FutureDateAllowed) {
                case 'MAX':
                    startDate = new Date();
                    START_DATE_EXPR = START_DATE_EXPR || new Date();
                    END_DATE = new Date();
                    END_DATE.setFullYear(END_DATE.getFullYear() + 100);
                    break;
                default:
                    END_DATE = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 59, 59);
                }

                if (scope.$eval(START_DATE_EXPR)) {
                    startDate = scope.$eval(START_DATE_EXPR);
                }

                // Get the current locale
                var localeCode = systemLanguageService.getSystemLanguage();

                // Configure the datepicker
                var minDate = startDate || EA_START_DATE;
                var yearRange = minDate.getFullYear() + ':' + END_DATE.getFullYear();
                // empty object, your custom options
                var options = $.extend({},
                    $.datepicker.regional[localeCode], {
                        showOn: '',
                        dateFormat: localizedOptions.getDatepickerFormat(),
                        changeMonth: true,
                        changeYear: true,
                        yearRange: yearRange,
                        minDate: startDate || EA_START_DATE,
                        maxDate: END_DATE,
                        showMonthAfterYear: true,
                        showOtherMonths: true,
                        selectOtherMonths: true,
                        showAnim: '',
                        showButtonPanel: true,
                        closeText: $filter('translate')('datepicker.clear'),
                        beforeShow: function (input) {
                            setTimeout(function () {
                                var clearButton = $(input).datepicker('widget').find('.ui-datepicker-close');
                                clearButton.bind('click', function () {
                                    $.datepicker._clearDate(input);
                                });
                            }, 1);
                        },
                        onChangeMonthYear: function (year, month, instance) {
                            setTimeout(function () {
                                var clearButton = $(instance).datepicker('widget').find('.ui-datepicker-close');
                                clearButton.bind('click', function () {
                                    $.datepicker._clearDate(instance.input);
                                });
                            }, 1);
                        }
                    }
                );
                $element.datepicker(options);

                var findScope = function (scope) {
                    var prop = attrs.dpModel.split('.')[0];
                    return scope.hasOwnProperty(prop) ? scope : findScope(scope.$parent);
                };

                var setDpModel = function () {
                    if (!attrs.dpModel) {
                        return;
                    }
                    var d = $element.datepicker('getDate');
                    var s = findScope(scope);
                    _.set(s, attrs.dpModel, d);
                };

                setDpModel();
                /**
                * If there is any date value present in ngModel, then, reassign the same with formatted date value
                */
                scope.$watch(attrs.ngModel, function (data) {
                    if(data || data === ''){
                        $element.datepicker('setDate', data);
                        setDpModel();
                        $element.datepicker({
                            dateFormat: localizedOptions.getDatepickerFormat()
                        });
                        $element.datepicker('refresh');
                    }
                });


                // Logic for "X" and "Calendar" button
                $element.parent().addClass('input-append date');
                $element.css('cursor', 'pointer');
                // Container element for "X" as well as "Calendar" button and icon.
                var $spanCalender = angular.element('<span class="add-on btn" style="padding: 0 5px 0 5px;height: 28px;border-left: 0"></span>'),
                    $calendarIcon = angular.element('<i class="icon-ico_calendar_sm" style="cursor: pointer;"></i>'),
                    $spanClose = angular.element('<span class="add-on btn" style="padding: 0 5px 0 5px;height: 28px;border-left: 0; display: none;"></span>'),
                    $closeIcon = angular.element('<i class="icon-ico_cross_rnd_sm" style="cursor: pointer;"></i>');

                $spanClose.bind('click', function () {
                    // Onclick of a "X" button, reset the textbox value as well as fire the "change" event to get te updated value in model.
                    // By default, only resetting the textbox value will not reset the value in model.
                    if (!$element.attr('disabled')) {
                        $element.val('');
                        $element.trigger('change');
                    }
                });

                $spanCalender.bind('click', function () {
                    // Onclick of a Calendar button, fire the "change" event to get the updated value in model.
                    // By default, only resetting the textbox value will not reset the value in model.
                    if (!$element.attr('disabled')) {
                        $element.trigger('change');
                        $element.datepicker('show');
                    }
                    $('#ui-datepicker-div').css('z-index', 99999);
                });

                // Appended "X" icon into "X" container
                $spanClose.append($closeIcon);

                // Appended "Calendar" icon into "Calendar" container
                $spanCalender.append($calendarIcon);

                // Append the "Calendar" button icon element just after the textbox
                $element.after($spanCalender);

                // Removes focus from input text on changing date value
                $element.bind('change', function () {
                    $element.blur();
                });
            }
        };
    }]);
});
